import { observer } from 'mobx-react';
import * as React from 'react';
import Button from '../../../Form/Button';
import clsx from 'clsx';

interface Props {
  handleOnClick: () => void;
  disabled: boolean;
}

const ContinueButton: React.FC<Props> = ({ handleOnClick, disabled }) => {
  return (
    <Button
      type="button"
      value="Continue"
      className={clsx(
        'ml-4 rounded-md bg-green-700 py-2.5 px-8 text-sm font-semibold text-white',
        'disabled:opacity-75',
      )}
      onClick={handleOnClick}
      disabled={disabled}
      intercomTarget="builder-continue-button"
    />
  );
};

export default observer(ContinueButton);
